import { Card, Accordion, AccordionGroup } from '../../elements/accordions/accordion-data';

const faq1: Accordion = {
    adClass: 'accordion-rounded',
    cardAclass: "card-box card-sm bg-light",
    cards: [
        {
            "title": "What kind of images can I generate with this tool?",
            "body": "You can generate a wide range of visuals — from photorealistic scenes and portraits to stylized concepts like watercolor, 3D render, anime, sketch, and more. Whether you're visualizing a marketing campaign, editorial idea, or creative concept, the tool adapts to your brief."
        },
        {
            "title": "Can I choose the image size or format?",
            "body": "Yes. You can choose between square, portrait, or landscape aspect ratios while generating your images — making them ready for social posts, banners, or print layouts without extra editing."
        },
        {
            "title": "Do I need to know how to write prompts?",
            "body": "Not at all. The tool works well with everyday language — but if you're looking for something specific, our prompt engineering team can guide you or even craft the ideal prompt for you."
        },
        {
            "title": "Can I use these images commercially?",
            "body": "All generated visuals are unique and royalty-free. However, if you're planning to use them in commercial campaigns or large-scale projects, you can request licensing through our team for added legal clarity."
        },
        {
            "title": "What if I want a set of images with the same look or character?",
            "body": "That’s where our Series Mode comes in — it lets you create multiple images that share a consistent subject, style, or theme. Great for storyboards, ad sets, or content series."
        },
        {
            "title": "What makes this tool different from stock photography?",
            "body": "Stock libraries are built from past images — this tool creates never-before-seen visuals on demand. It’s like having a creative studio in your browser, with no search fatigue or usage limits."
        },
        {
            "title": "Can I edit or fine-tune the image later?",
            "body": "You can always run a new prompt with adjustments, or let our team help refine it. Some post-processing may also be done using standard design tools, once downloaded."
        },
        {
            "title": "Can I get support for complex briefs?",
            "body": "Absolutely. If your project needs precision — whether it’s a specific scene, cultural nuance, or recurring visual — our human support team can step in and guide the AI to deliver what you need."
        },
        {
            "title": "What types of visuals can I create with IndiaPicture.in AI?",
            "body": "You can generate anything from lifelike scenes and portraits to stylized art like watercolor, 3D renders, illustration, and digital concept art. Just describe your subject, mood, style, and lighting — and our AI will adapt to your brief."
        },
        {
            "title": "What if I don’t get what I need on the first try?",
            "body": "All good. You can refine your prompt and generate again as often as needed. Or contact our prompt engineering team for expert guidance or a custom prompt to match your exact vision."
        },
        {
            "title": "What is the image resolution and upscaling workflow?",
            "body": "Generated images come in high native resolution (e.g. 2048 × 2048 px). If you need larger formats, you can upscale with one click for crisp, print-quality outputs — with no loss of detail."
        },
        {
            "title": "How do licensing and usage rights work?",
            "body": "Your visuals remain exclusive to you. While you can use them royalty‑free across most personal and marketing contexts, if you need additional legal security — such as full commercial indemnity or redistributing to clients — you may request licensing assistance through our team."
        },
        {
            "title": "Will images I generate appear in public libraries?",
            "body": "No. Every image created with your prompt is unique and will not become part of any public stock collection. The visuals remain licensed solely to you and are not shared or re-used."
        }
    ]
}

export const faqGroups: AccordionGroup[] = [
    {
        title: "IndiaPicture.com AI Tool– FAQs",
        items: [
            faq1
        ]
    }
]